/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { createStructuredSelector } from 'reselect'
import { signUpArtist, signUpCurator } from 'Redux/actions/auth'
import Component from './SingUp'

const selector = createStructuredSelector({
  formStates: state => getFormValues('sign_up_form')(state),
})

const actions = {
  onSignUpArtist: signUpArtist,
  onSignUpCurator: signUpCurator,
}

export default connect(selector, actions)(Component)
